import { SIGNUP_PAGE } from 'src/constants';
import { isStudioReferrer } from 'src/routes/onboarding/setup/constants';

/** One-shot resume after re-auth when Cognito session was expired on select-email. */
export const STUDIO_POST_LOGIN_RESUME_KEY = 'studioOnboardingPostLoginResume';

export const storeStudioPostLoginResume = (path: string): void => {
  if (typeof window === 'undefined') {
    return;
  }
  window.sessionStorage.setItem(STUDIO_POST_LOGIN_RESUME_KEY, path);
};

/**
 * Returns and clears a stored Studio signup resume path, or null if missing/invalid.
 * Only `/signup?referrer=studio…` paths are accepted to avoid open redirects.
 */
export const consumeStudioPostLoginResume = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const path = window.sessionStorage.getItem(STUDIO_POST_LOGIN_RESUME_KEY);
  window.sessionStorage.removeItem(STUDIO_POST_LOGIN_RESUME_KEY);

  if (!path) {
    return null;
  }

  try {
    const url = new URL(path, window.location.origin);
    if (
      url.origin !== window.location.origin ||
      url.pathname !== SIGNUP_PAGE ||
      !isStudioReferrer(url.searchParams.get('referrer') ?? undefined)
    ) {
      return null;
    }
    return `${url.pathname}${url.search}`;
  } catch {
    return null;
  }
};
